declare namespace $ {

	type $mol_view__dom_name_shm_hitalama_map_widget_float_rect_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__dom_name_space_shm_hitalama_map_widget_float_rect_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name_space'] >
	>
	type $mol_view__attr_shm_hitalama_map_widget_float_rect_3 = $mol_type_enforce<
		({ 
			'x': string,
			'y': string,
			'width': string,
			'height': string,
			'fill': ReturnType< $shm_hitalama_map_widget_float_rect['fill'] >,
			'stroke': ReturnType< $shm_hitalama_map_widget_float_rect['stroke'] >,
			'stroke-width': ReturnType< $shm_hitalama_map_widget_float_rect['stroke_width'] >,
			'vector-effect': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__dom_name_shm_hitalama_map_widget_float_rect_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__dom_name_space_shm_hitalama_map_widget_float_rect_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name_space'] >
	>
	type $mol_view__attr_shm_hitalama_map_widget_float_rect_6 = $mol_type_enforce<
		({ 
			'viewBox': string,
			'preserveAspectRatio': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_shm_hitalama_map_widget_float_rect_7 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_widget_float_rect['content_pointerdown'] > ): ReturnType< $shm_hitalama_map_widget_float_rect['content_pointerdown'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_rect_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_float_rect extends $shm_hitalama_map_widget_float {
		content_pointerdown( next?: any ): any
		fill( ): string
		stroke( ): string
		stroke_width( ): string
		Rect( ): $mol_view
		Svg( ): $mol_view
		scrollable( ): boolean
		controls( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=rect.view.tree.d.ts.map